<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      title="查看 发货通知单"
      id-key="DeliveryDocId"
      :data="data"
      :line-form="true"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      :save-func="() => {}"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="row-head">基本信息</div>
        <el-row class="border">
          <el-row :gutter="15">
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="订单编号">
                <span class="detail-span">{{ data.OrderNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="通知单号">
                <span class="detail-span">{{ data.TradeUnitNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="客户名称">
                <span class="detail-span">{{ data.FullName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="提交人">
                <span class="detail-span">
                  <span>{{ data.EmpName }}</span>
                  <!-- <span v-if="data.Phone">/{{data.Phone}}</span>
                  <span v-if="data.Address">/{{data.Address}}</span> -->
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="提交时间">
                <span class="detail-span">{{
                  $commonJs.toDateString(data.DeliveryDate)
                }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="发货方式">
                <span class="detail-span">{{ getDeliveryWay(data.DeliveryWay) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <el-divider>货品信息</el-divider>

        <el-table class="table-line tb-c-head" :data="data.Products" border>
          <el-table-column
            label="产品编号"
            align="center"
            prop="ProductNo"
            min-width="150"
          />
          <el-table-column
            label="产品名称"
            align="center"
            prop="ProductName"
            min-width="150"
          />
          <el-table-column
            label="规格型号"
            align="center"
            prop="ProductSpec"
            min-width="90"
          />
          <el-table-column
            label="模号"
            align="center"
            prop="MouldNo"
            min-width="120"
          />
          <el-table-column
            label="订单数量"
            align="center"
            prop="SaQuantity"
            min-width="120"
          />
          <el-table-column
            label="已生产数量"
            align="center"
            prop="ProductionQuantity"
            min-width="120"
          />
          <el-table-column
            label="可发货数量"
            align="center"
            prop="InventoryQuantity"
            min-width="120"
          />
          <el-table-column
            label="发货数量"
            align="center"
            prop="Quantity"
            min-width="120"
          />
        </el-table>
      </template>
      <template slot="footer">
        <template v-if="isReview">
          <el-button :loading="isLoading" type="success" @click="review"
            >通 过</el-button
          >
          <el-button :loading="isLoading" type="danger" @click="back"
            >退 回</el-button
          >
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/sa/deliveryDoc").default,
      data: {
        DeliveryDocId: 0,
        DeliveryDocNo: "",
        OrderId: 0,
        OrderNo: "",
        TradeUnitNo: "",
        FullName: "",
        Person: "",
        Phone: "",
        Address: "",
        DeliveryWay:0,
        DeliveryDate: this.$commonJs.getToday(), //发货日期

        EmpId: null, //经办人Id
        EmpName: "",
        Remark: "",
        Status: 0,
        Products: [],
      },
      isReview: false,
      isMB: this.$store.state.isMB,
    };
  },
  computed: {},
  methods: {
    getDeliveryWay(data) {
     
      // 0：送货/1：物流/2：快递/3：自提
      if (Number(data) === 0) return "送货";
      if (Number(data) === 1) return "物流";
      if (Number(data) === 2) return "快递";
      if (Number(data) === 3) return "自提";
    },
    onEditOpened(data) {
      this.isReview = true;
      // console.log("onEditOpened", data);
      this.api.info(data.DeliveryDocId).then(res=>{
         this.data = res.Data;
      })
    },
    review() {
      this.$refs.dialog.isLoading = true;
      this.isLoading = true;
      this.api.review(this.data.DeliveryDocId).then((res) => {
        this.$refs.dialog.isLoading = false;
        this.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    back() {
      this.$refs.dialog.isLoading = true;
      this.isLoading = true;
      this.api.back(this.data.DeliveryDocId).then((res) => {
        this.$refs.dialog.isLoading = false;
        this.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onClosed() {
      this.data.Products = [];
      this.isReview = false;
    },
  },
};
</script>
